var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCampaign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 3.33329H2.16683C1.7469 3.33329 1.34418 3.50011 1.04724 3.79704C0.750311 4.09397 0.583496 4.4967 0.583496 4.91663V8.08329C0.583496 8.50322 0.750311 8.90594 1.04724 9.20288C1.34418 9.49981 1.7469 9.66663 2.16683 9.66663H2.9585V12.8333C2.9585 13.0433 3.0419 13.2446 3.19037 13.3931C3.33884 13.5416 3.5402 13.625 3.75016 13.625H5.3335C5.54346 13.625 5.74482 13.5416 5.89329 13.3931C6.04175 13.2446 6.12516 13.0433 6.12516 12.8333V9.66663H8.50016L12.4585 12.8333V0.166626L8.50016 3.33329ZM16.021 6.49996C16.021 7.85371 15.261 9.08079 14.0418 9.66663V3.33329C15.2531 3.92704 16.021 5.15413 16.021 6.49996Z",
    fill: "#17A2B8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.16c0f613.svg";
export { ForwardRef as ReactComponent };